import React, { Component } from 'react';
import ReactSelect from 'react-select';
import { Typography } from '@material-ui/core';
import '../../node_modules/react-select/dist/react-select.css';
import './ComboBoxSearch.css';

class ComboBoxSearch extends Component {
  state = {
    selectedOption: ""
  };

  handleOnChange = selectedOption => {
    if (selectedOption) {
      this.props.onItemChange(selectedOption);
      this.setState({ selectedOption: selectedOption.value });
    } else {
      this.props.onItemChange(null);
      this.setState({ selectedOption: null });
    }
  };

  renderOption = option => {
    return (
      <Typography variant="body2" style={{lineHeight: 'unset'}}>{option.label} ({option.level})</Typography>
    );
  };

  renderValue = option => {
    return (
      <Typography variant="body2" style={{lineHeight: 'unset'}}>{option.label} ({option.level})</Typography>
    );
  };

  render() {
    const { selectedOption } = this.state;
    const { mobile } = this.props;

    return (
      <div>
        {mobile ? (
          <div className="mobile-comboBoxSearch-container">
            <ReactSelect
              name="comboBoxSearch"
              value={selectedOption}
              onChange={this.handleOnChange}
              options={this.props.items}
              optionRenderer={this.renderOption}
              valueRenderer={this.renderValue}
              searchable={true}
              placeholder={this.props.placeholder}
            />
          </div>
        ) : (
          <div className="comboBoxSearch-container">
            <ReactSelect
              name="comboBoxSearch"
              value={selectedOption}
              onChange={this.handleOnChange}
              options={this.props.items}
              optionRenderer={this.renderOption}
              valueRenderer={this.renderValue}
              searchable={true}
              placeholder={this.props.placeholder}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ComboBoxSearch;



// WEBPACK FOOTER //
// ./src/components/ComboBoxSearch.js